import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetDepreciationSingleReport  {
    _originalTypeClassName = "zERP.BO.AssetDepreciationSingleReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetDepreciationSingleReport.translate = translateService;
}
this.AssetDepreciationSingleReportKey = null;
this._key = this.AssetDepreciationSingleReportKey = 0; 
}

static translate: TranslateService;
_key: any;
Asset:any;
TaxReport:any;
AccountingReport:any;
private _AssetDepreciationSingleReportKey:any;
get AssetDepreciationSingleReportKey(): any {
    return this._AssetDepreciationSingleReportKey;
  }
set AssetDepreciationSingleReportKey(value: any) {
    this._AssetDepreciationSingleReportKey = value;
    this._key = value;
  }
static setAsset = ($this, value) => {
var oldValue = $this.Asset;
$this.Asset = value;
if (value != null) {
}
}
static setTaxReport = ($this, value) => {
var oldValue = $this.TaxReport;
$this.TaxReport = value;
if (value != null) {
}
}
static setAccountingReport = ($this, value) => {
var oldValue = $this.AccountingReport;
$this.AccountingReport = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AssetDepreciationSingleReportKey == null || $this.AssetDepreciationSingleReportKey == 0;
            }


}